import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Homepage from './pages/homepage';
import SelectProblem from './pages/select-problem';
import ChatPage from './pages/chat';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router';

const API_ROOT = "https://aimi-functions-cwg6dzdneadjhxe5.westus-01.azurewebsites.net/api";
const SECURITY_TOKEN = 'QWRhRGV2ZWxvcGVyc0FjYWRlbXlNb2NrSW50ZXJ2aWV3Qm90RGVtb0p1bHkyMDI1';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Routes>
        <Route
          path="/"
          element={<Homepage />}
        />
        <Route
          path="/select-problem"
          element={<SelectProblem API_ROOT={API_ROOT} SECURITY_TOKEN={SECURITY_TOKEN} />}
        />
        <Route
          path="/chat/:problemId"
          element={<ChatPage API_ROOT={API_ROOT} SECURITY_TOKEN={SECURITY_TOKEN} />}
        />
      </Routes>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
